import Vue from 'vue'
import HeadButton from './button'

Vue.component('head-button', HeadButton)



// WEBPACK FOOTER //
// ./src/components/HeadButton/index.js